import React from 'react';
import styles from './plan.module.scss';

const PlanComponent = ({ onClick = { onClick }, planOfferText, planUpgradeText, product_sku, title, discountToAnnual, displayName, price, discounted_price, subscription_period, isPopular, showSavings, savingAmount, selected, planInfo, show_monthly_price, currency_symbol, duration_months, bogo }) => {

  let display_period = '/mo';
  let discount_period = '';

  if (subscription_period == "lifetime") {
    display_period = '/once';
    discount_period = 'forever';
  }

  let display_price = discounted_price > 0 ? discounted_price : price;
  let originalPrice = price;
  if (subscription_period == 'annual' && show_monthly_price) {
    // calculate monthly pricing for display
    originalPrice = (Math.floor(price / 12 * 100) / 100).toFixed(2);
    display_price = (Math.floor(display_price / 12 * 100) / 100).toFixed(2);
    discount_period = 'first year';
  }

  if (subscription_period == 'monthly') {
    // calculate monthly pricing for display
    originalPrice = (Math.floor(price / duration_months * 100) / 100).toFixed(2);
    display_price = (Math.floor(display_price / duration_months * 100) / 100).toFixed(2);
  }

  function getPlanInfoClass() {
    if (subscription_period === "monthly" && selected) {
      return `${styles.planInfo} ${styles.showPlanInfo}`;
    } else {
      return `${styles.planInfo} ${styles.hidePlanInfo}`;
    }
  }

  function decodeHtmlEntity(str) {
    const textArea = document.createElement('textarea');
    textArea.innerHTML = str;
    return textArea.value;
  }

  const decodedCurrencySymbol = decodeHtmlEntity(currency_symbol);

  return (
    <>
      <div id={"yc-cta-plan-select-"+subscription_period} onClick={onClick} className={`${styles.plan} ${isPopular ? styles.popular : ''} ${selected ? styles.selected : ''}`}>
        {/* {isPopular && <div className={styles.popularTag}>Most popular</div>} */}
        <div className={styles.TitlePrice}>
          <div className={styles.col1}>
            <div className={styles.title} data-selected={selected}>{displayName}</div>
            { false && <div className={styles.totalPricing}>
              {!!discounted_price && (<div className={styles.totalDiscountedPrice}>{decodedCurrencySymbol}{discounted_price}</div>)}
              <div className={`${styles.totalPrice} ${discounted_price ? styles.strikethrough : ''}`}>{decodedCurrencySymbol}{price}</div>
            </div>}
          </div>
          <div className={styles.col2}>
            <div className={styles.pricing}>
              <span className={styles.currentPrice}>
                <span className={styles.currencySymbol}>{decodedCurrencySymbol}</span>
                <span className={styles.discountedPrice}>{Math.floor(display_price)}</span>
                <span className={styles.discountedPriceDigits}>.{Math.round((display_price - Math.floor(display_price)) * 100).toString().padStart(2, '0')}</span>
                <span className={styles.perMonth}>{display_period}</span>
              </span>
            </div>
            {discounted_price && <div className={styles.priceWithoutDiscount}>
              <span className={styles.strikethrough}>{decodedCurrencySymbol}{price}</span> {subscription_period === 'annual' ? `${decodedCurrencySymbol}${discounted_price}` : ''} {discount_period}
            </div>}
            {!discounted_price && subscription_period === "monthly" && duration_months === 3 && <div className={styles.priceWithoutDiscount}>
              {decodedCurrencySymbol}{price} every {duration_months} months
            </div>}
          </div>
        </div>
        <div className={styles.promoBlock}>
          <div className={styles.promoText}>{planOfferText?.replace('{discount_to_annual}', `${decodedCurrencySymbol}${Math.ceil(discountToAnnual)}`)}</div>
          {selected && subscription_period === 'monthly' && <div className={styles.promoUpgrade}>{planUpgradeText?.replace('{discount_to_annual}', `${decodedCurrencySymbol}${Math.ceil(discountToAnnual)}`)}</div>}
        </div>
      </div>
      {false && <div className={getPlanInfoClass()}>{planInfo}</div>}
    </>
  );
};

export default PlanComponent;